// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4307":"744eb6cc","6895":"c0411d85"}[chunkId] + ".chunk.css";
};